import React from 'react';
import './career.css';
import SampleImg from '../../Data/Assets/images/sample_img.png';
import Navbar from '../home_page/navbar';
import Footer from '../home_page/footer';
import InternshipCards from './internship_cards';

function Career() {
  return (
    <div>
      <Navbar></Navbar>
      <div className="career-content-container">
        <div className="career-page-title">Join India's next-gen Nuclear Movement!</div>
        <div className="career-page-content">
          At the IYNS Research Foundation, we empower students and professionals to explore careers
          in nuclear science, policy, and innovation.
        </div>
        <div className="career-image-display">
          <div className="iyns-career img-1">
            <img src={SampleImg} alt="IYNS"></img>
          </div>
          <div className="iyns-career img-2">
            <img src={SampleImg} alt="IYNS"></img>
          </div>
          <div className="iyns-career img-3">
            <img src={SampleImg} alt="IYNS"></img>
          </div>
        </div>
        <div className="container-fluid">
          <div className="what-we-offer">
            <p className="offer-title">What We Offer</p>
            <p className="what-we-offer offers">
              Internships with leading global orgs like ITER, France.
            </p>
            <p className="what_we_offer offers">
              Research & Outreach Roles in science communication and nuclear advocacy.
            </p>
            <p className="what_we_offer offers">Event & Project Opportunities across India.</p>
          </div>
          <InternshipCards></InternshipCards>
        </div>
      </div>
      <Footer></Footer>
    </div>
  );
}

export default Career;
